"use client"

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import React from "react"

function Step({ number, label }: { number: number; label: string }) {
  return (
    <div className="flex flex-col items-center text-center flex-1 min-w-[100px]">
      <div className="w-8 h-8 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-bold mb-2">{number}</div>
      <div className="font-medium text-gray-800 text-base md:text-lg">{label}</div>
    </div>
  )
}

export function QuickStartSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-green-50 via-white to-green-100 border-t border-green-100 transition-all duration-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-green-700 drop-shadow-sm">Get started in under 2 minutes</h2>
          <p className="text-xl text-gray-700">
            Getting started with revvu is easy. Just follow these 3 steps:
          </p>
        </div>
        <Card className="max-w-2xl mx-auto border-green-200 shadow-2xl rounded-2xl bg-white/90 backdrop-blur-md">
          <CardHeader>
            <CardTitle className="text-xl text-green-800 text-center w-full">Quick Setup</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col md:flex-row gap-4 w-full justify-center mb-6">
              <Step number={1} label="Create a revvu account" />
              <Step number={2} label="Connect your social accounts" />
              <Step number={3} label="Connect your affiliate programs" />
            </div>
            <button
              className="bg-green-500 text-white font-medium px-6 py-3 rounded-lg text-base shadow-md w-full mt-2 opacity-60 cursor-not-allowed"
              disabled
            >
              Coming soon
            </button>
          </CardContent>
        </Card>
      </div>
    </section>
  )
}
